import { ChainId } from 'bakery-swap-sdk'

export const PetType = Object.freeze({
  kitten: 1,
  puppy: 2,
  bunny: 3
})
export const supportPetType: number[] = Object.values(PetType)
export const petMap = {
  name: {
    [PetType.kitten]: 'Kitten',
    [PetType.puppy]: 'Puppy',
    [PetType.bunny]: 'Bunny'
  },
  eggIcon: {
    [PetType.kitten]: 'kitten.svg',
    [PetType.puppy]: 'puppy.svg',
    [PetType.bunny]: 'bunny.svg'
  }
}
export const BACKGROUND: string[] = ['#F8FAF4', '#FEF9F8', '#F9F5F9', '#F3F8FD', '#F1F4E6', '#FDF2F6', '#FEFBE6', '#EEF8FC', '#FEF8ED']

export const BNB = 'wbnb'
export const CONTRACT_ADDRESSES: { [contract: string]: { [chainId: string]: string } } = {
  pet: {
    [ChainId.BSC_TESTNET]: '0xe59af933b309aFF12f323111B2B1648fF45D5dc0',
    [ChainId.BSC_MAINNET]: '0x4d4e595d643dc61EA7FCbF12e4b1AAA39f9975B8'
  },
  petEggNft: {
    [ChainId.BSC_TESTNET]: '0x0B619B394cA844576E571E43b6A120882Eb8C59a',
    [ChainId.BSC_MAINNET]: '0x8A3ACae3CD954fEdE1B46a6cc79f9189a6C79c56'
  },
  petIdo: {
    [ChainId.BSC_TESTNET]: '0x973df181FC4b317bcb961540cB5F2034AaEAfC3b',
    [ChainId.BSC_MAINNET]: '0xD88ff9035a8abF2E973f9d30baFaE7eF28AAa630'
  },
  wbnb: {
    [ChainId.BSC_TESTNET]: '0x094616f0bdfb0b526bd735bf66eca0ad254ca81f',
    [ChainId.BSC_MAINNET]: '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c'
  },
  busd: {
    [ChainId.BSC_TESTNET]: '0xed24fc36d5ee211ea25a80239fb8c4cfd80f12ee',
    [ChainId.BSC_MAINNET]: '0xe9e7cea3dedca5984780bafc599bd69add087d56'
  },
  bakery: {
    [ChainId.BSC_TESTNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5',
    [ChainId.BSC_MAINNET]: '0xe02df9e3e622debdd69fb838bb799e3f168902c5'
  },
  tether: {
    [ChainId.BSC_TESTNET]: '0x337610d27c682E347C9cD60BD4b3b107C9d34dDd',
    [ChainId.BSC_MAINNET]: '0x55d398326f99059ff775485246999027b3197955'
  },
  doggy: {
    [ChainId.BSC_TESTNET]: '0x1f79374402b770ced370cea67124000b2b5ef54f',
    [ChainId.BSC_MAINNET]: '0x74926B3d118a63F6958922d3DC05eB9C6E6E00c6'
  }
}
